import { render, staticRenderFns } from "./DHLDialog.vue?vue&type=template&id=28a81f4b"
import script from "./DHLDialog.vue?vue&type=script&lang=js"
export * from "./DHLDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports